module.exports = __webpack_public_path__ + "img/LTS_Tipp.05ced179.gif";